import { Button, Css, DnDGrid, useModal } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { observer } from "mobx-react";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { AddOptionModal } from "src/routes/bids/plan-based-bid-package/components/AddOptionModal";
import { OptionCard } from "src/routes/bids/plan-based-bid-package/components/OptionCard";
import { groupKey, PlanBasedBidPackageFormState, reorderGroups } from "src/routes/bids/plan-based-bid-package/utils";

type OptionsSectionProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
  potentialBidPlanOptions: ConfigureBidGroupsStepQuery["bidPackage"]["potentialBidPlanOptions"];
};

export const OptionsSection = observer(function OptionsSection(props: OptionsSectionProps) {
  const { formState, dimensionResults, potentialBidPlanOptions } = props;
  const { openModal } = useModal();
  const optionGroups = formState.bidPlanGroups.rows
    .filter((g) => !!g.globalOptionId.value)
    .sortBy((g) => g.order.value ?? Infinity);

  function openAddOptionModal() {
    openModal({
      content: (
        <AddOptionModal
          formState={formState}
          dimensionResults={dimensionResults}
          potentialBidPlanOptions={potentialBidPlanOptions}
        />
      ),
    });
  }

  return (
    <div css={Css.df.fdc.gap2.$}>
      <div css={Css.df.aic.jcsb.$}>
        <div css={Css.lg.$}>Options</div>
        <Button icon="plus" label="Add Options" variant="secondary" onClick={openAddOptionModal} />
      </div>
      {optionGroups.isEmpty ? (
        <div css={Css.bgGray100.br8.py3.tac.gray700.$}>No options added.</div>
      ) : (
        <DnDGrid
          onReorder={(newIds) =>
            formState.bidPlanGroups.set(reorderGroups(formState.bidPlanGroups.value ?? [], newIds))
          }
          gridStyles={Css.dg.gtc("minmax(0, 1fr)").gap2.$}
        >
          {optionGroups.map((group) => (
            <OptionCard
              key={groupKey(group.value)}
              formState={formState}
              group={group}
              dimensionResults={dimensionResults}
              potentialBidPlanOptions={potentialBidPlanOptions}
            />
          ))}
        </DnDGrid>
      )}
    </div>
  );
});
